import { IAccount } from '@/server/models/account';
import { UserFormSchemaType } from '../_components/Profile/Form';
import { getAxios, handleAxiosError } from './axios';
import { useQuery } from '@tanstack/react-query';

export const saveProfile = (body: UserFormSchemaType) => {
  const axios = getAxios();
  return axios.post(`/user`, body);
};

export const useAccountList = (params: { id?: string; count?: number }) => {
  const axios = getAxios();

  const query = useQuery({
    queryKey: ['/accounts', params],
    queryFn: () =>
      axios.get<{ data: IAccount[] }>(`/accounts`, {
        params,
      }),
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError(error) {
      handleAxiosError()(error);
      return false;
    },
  });

  return {
    accounts: query.data?.data.data || [],
    query: query,
  };
};
